module.exports = "/_next/static/images/tl-fe2733666f2553d2b1a66aeae921a644.svg";